export default "__VITE_ASSET__DLmnSkqq__"